import * as React from "react";
/* empty css                 */
const ProductList = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "try-in-store-modal__product-list" }, children);
};
export {
  ProductList
};
//# sourceMappingURL=ProductList.js.map
